const glassFitterService = {
  title: "Glass Fitter",
  icon: "🪟",
  shortDescription:
    "Glass fitting, replacement support, panel alignment, and minor glasswork jobs.",
  longDescription:
    "Book glass fitting support for panel replacement, alignment, fitting correction, and glass-related installation work.",
  consultationNote:
    "Custom glass size jobs and major replacement work may require inspection first.",
  responsePromise:
    "Assignment depends on glass type, fitting nature, and safety feasibility.",
  warrantyPolicy:
    "Support depends on fitting type, glass condition, and job scope.",
  subServices: [
    {
      id: "glass-panel-fitting",
      title: "Glass Panel Fitting",
      icon: "🪟",
      group: "Fitting",
      description:
        "Fit or refit glass panel where frame and panel conditions are suitable.",
      basePrice: 899,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "glass-alignment-correction",
      title: "Glass Alignment Correction",
      icon: "📏",
      group: "Correction",
      description:
        "Correct minor misalignment or looseness in existing glass panel systems.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "1-2 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "glass-handle-fitting",
      title: "Glass Handle / Accessory Fitting",
      icon: "🔧",
      group: "Accessories",
      description:
        "Install or adjust handle or accessory attached to glass fitting systems.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "30-60 mins",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "glass-inspection",
      title: "Glass Work Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for replacement, breakage handling, frame compatibility, or estimate planning.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default glassFitterService;